var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 34.431,
    viewBox: "0 0 280 34.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eb684a;}.b{fill:#014671;}.c{fill:#40b9c3;}.d{fill:#3a6cb3;}.e{fill:#ac4994;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61.594 -194.204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.956,217.684c.039-.407.061-.817.061-1.231a12.708,12.708,0,0,0-3.784-9.061,12.467,12.467,0,0,0-9.008-3.677,12.765,12.765,0,1,0,0,25.53,12.663,12.663,0,0,0,9.008-3.731c.171-.172.324-.356.485-.533l-5.1-3.587a6.466,6.466,0,0,1-4.389,1.722,6.564,6.564,0,0,1-6.387-5.431Zm-12.731-7.893a6.536,6.536,0,0,1,5.8,3.571H340.472A6.5,6.5,0,0,1,346.225,209.791Z",
    transform: "translate(-17.423 -0.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.146,228.662V215.6a5.1,5.1,0,0,0-5.171-5.117,5.2,5.2,0,0,0-5.169,5.117v13.059h-6.663V204.251h6.663v1.759a7.047,7.047,0,0,1,5.169-2.24A11.739,11.739,0,0,1,144.861,215.6v13.059Z",
    transform: "translate(-3.817 -0.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M160.066,228.049a8.624,8.624,0,0,1-6.129-2.5,8.5,8.5,0,0,1-2.5-6.13V209.288h-3.411V203.8h3.411V194.2h6.343V203.8h7.089v5.49h-7.089v10.02a2.6,2.6,0,0,0,2.344,2.559h4.637l1.705,6.183Z",
    transform: "translate(-5.539 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.286,228.655V204.244H177v1.973a9.888,9.888,0,0,1,6.716-2.559h1.6l-1.6,6.662H182.7A5.58,5.58,0,0,0,177,215.7v12.952Z",
    transform: "translate(-6.966 -0.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M189.619,225.464a12.738,12.738,0,0,1,0-18.015,12.606,12.606,0,0,1,9.007-3.678,8.731,8.731,0,0,1,6.023,2.4l.267.212v-2.132h6.449v24.411h-6.449v-1.919l-.267.267a8.028,8.028,0,0,1-6.023,2.131A12.793,12.793,0,0,1,189.619,225.464Zm2.718-9.007a6.291,6.291,0,1,0,6.289-6.449A6.44,6.44,0,0,0,192.337,216.457Z",
    transform: "translate(-7.966 -0.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.686,225.514l-.053-.053a12.712,12.712,0,0,1,9.061-21.746,12.259,12.259,0,0,1,9.007,3.677,16,16,0,0,1,1.332,1.493l.64.959-5.223,3.891-.746-1.012a6.309,6.309,0,1,0-5.01,10.233,6.311,6.311,0,0,0,5.01-2.878l.693-.96,5.436,3.892-.8,1.013a3.439,3.439,0,0,1-.426.478c-.267.321-.586.693-.906,1.014a12.651,12.651,0,0,1-9.007,3.677A12.837,12.837,0,0,1,219.686,225.514Z",
    transform: "translate(-9.893 -0.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M254.251,228.049a8.62,8.62,0,0,1-6.128-2.5,8.494,8.494,0,0,1-2.5-6.13V209.288h-3.411V203.8h3.411V194.2h6.342V203.8h7.089v5.49H251.96v10.02a2.6,2.6,0,0,0,2.345,2.559h4.637l1.706,6.183Z",
    transform: "translate(-11.576 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M265.356,225.464a12.74,12.74,0,0,1,0-18.015,12.611,12.611,0,0,1,9.008-3.678,8.728,8.728,0,0,1,6.022,2.4l.267.212v-2.132H287.1v24.411h-6.449v-1.919l-.267.267a8.025,8.025,0,0,1-6.022,2.131A12.8,12.8,0,0,1,265.356,225.464Zm2.719-9.007a6.291,6.291,0,1,0,6.289-6.449A6.44,6.44,0,0,0,268.074,216.457Z",
    transform: "translate(-12.821 -0.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M300,226.4l-.266-.267v1.919h-6.449V194.216h6.449v11.555l.266-.212a8.735,8.735,0,0,1,6.023-2.4,12.609,12.609,0,0,1,9.007,3.678,12.685,12.685,0,0,1-9.007,21.692A8.031,8.031,0,0,1,300,226.4Zm6.023-4.1a6.451,6.451,0,1,0-6.289-6.448A6.44,6.44,0,0,0,306.025,222.293Z",
    transform: "translate(-14.85 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M323.125,228.05V194.216h6.929V228.05Z",
    transform: "translate(-16.762 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.776,225.493a13.158,13.158,0,0,1-3.731-9.061,12.651,12.651,0,0,1,12.792-12.739,12.467,12.467,0,0,1,9.008,3.678,12.791,12.791,0,0,1-9.008,21.852A13.157,13.157,0,0,1,94.776,225.493Zm2.558-9.061a6.531,6.531,0,1,0,6.5-6.663A6.6,6.6,0,0,0,97.334,216.433Z",
    transform: "translate(-1.888 -0.608)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.594 203.112)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.432,219.126l-.694.959a7.636,7.636,0,0,1-.905,1.055,5.943,5.943,0,0,1-4.1,1.824,6.341,6.341,0,0,1-5.658-3.844,6.225,6.225,0,0,1,10.668-6.39l.746,1.013,5.223-3.891-.639-.959a15.771,15.771,0,0,0-1.333-1.493,12.255,12.255,0,0,0-9.007-3.678,12.561,12.561,0,0,0-12.739,12.74,12.7,12.7,0,0,0,.475,3.388,6.855,6.855,0,0,0-3.872,1.976c2.322-.776,5.011,2.2,7.719,4.222a12.854,12.854,0,0,0,14.048,1.861,13.035,13.035,0,0,0,1.242-.7c.08-.046.16-.087.24-.135l-.007-.014a12.187,12.187,0,0,0,1.9-1.537c.32-.319.64-.692.906-1.013a3.447,3.447,0,0,0,.427-.478l.8-1.014Z",
    transform: "translate(-61.594 -203.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.5,206.6c-.037-.03-.08-.052-.118-.082.038.029.077.058.114.088Z",
    transform: "translate(-61.901 -203.901)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d675021b52ded5f85afb05f0371006d9.svg";
export { ForwardRef as ReactComponent };